<div class="grid_row">
    <div class="border-right d-flex flex-column justify-content-between py-3 pr-3 grid_part">
        <mat-tab-group class="rig_innertab" [(selectedIndex)]="selectLeftTabIndex"
            (selectedTabChange)="leftTabMenuChanged($event)">
            <mat-tab label="Description">
            </mat-tab>
            <mat-tab label="Document View"></mat-tab>
        </mat-tab-group>
        <app-progress-bar [isLoading]="mappingLoading"></app-progress-bar>
        <div *ngIf="isDescriptionView" class="right_part">
            <div>
                <div class="card w-100 p-3">
                    <div class="d-flex align-items-center justify-content-between w-100 gap-2 flex-wrap mb-3">
                        <h3 class="">Description</h3>
                        <!-- <lucide-icon size="16" name="square-pen" class="text-blue-lucide cursor-pointer"
                            matTooltip="Edit" (click)="editButtonClick()"></lucide-icon> -->
                    </div>
                    <div *ngFor="let desc of policyMappingDescription"
                        class="d-flex gap-3 align-items-start policyMapping">
                        <h4 *ngIf="desc.IsOriginal" class="mb-0">Regulators Description</h4>
                        <h4 *ngIf="!desc.IsOriginal" class="mb-0">{{ desc.Jurisdiction }}-{{ desc.User }}</h4>
                        <div class="disableText w-100">
                            <div *ngIf="desc.Description | hasHtmlTags; else noHtmlTags" [innerHTML]="desc.Description">
                            </div>
                        </div>
                        <ng-template #noHtmlTags>
                            <p class="description">{{desc.Description}}</p>
                        </ng-template>
                        <input type="checkbox" (change)="addDescription(desc,$event.target.checked)" />
                    </div>
                </div>
                <div class="card w-100 p-3 mt-3">
                    <h3 class="mb-2">Linked Documents</h3>
                    <div *ngFor="let link of linkedDocumentsArray"
                        class="d-flex justify-content-between w-100 align-items-start gap-3 my-1">
                        <a *ngIf="!isPdfLink(link)" href="{{ link }}" target="_blank">{{ link }} </a>
                        <a *ngIf="isPdfLink(link)" (click)="openPdf(link)">{{ link }} </a>
                        <input type="checkbox" (change)="addLinkedDocuments(link,$event.target.checked)" />
                    </div>
                </div>
                <div class="card w-100 p-3 mt-3" *ngIf="isShowMappedRegulatory">
                    <h3 class="mb-2">Mapped Regulatory Text</h3>
                    <div *ngFor="let reg of matchPolicies"
                        class="d-flex justify-content-between w-100 align-items-start matchPolicies_div gap-3 my-1">
                        <p matTooltip="{{reg.page_content}}" matTooltipPosition="above" matTooltipClass="rig_tooltip">
                            {{reg.matchingUpdateDesc}}</p>
                        <div class="d-flex gap-1">
                            <!-- <lucide-icon [matTooltipMultiline]="true" name="info"
                                matTooltip="Suggest Name: {{ reg.meta_data | policyMetaDataJsonArray:'suggestedName' }}, Source: {{ reg.meta_data | policyMetaDataJsonArray:'Source' }}, Page: {{ reg.meta_data | policyMetaDataJsonArray:'page' }}"
                                size="18" class="text-blue-lucide"></lucide-icon> -->
                            <lucide-icon [matTooltipMultiline]="true" name="info" matTooltipClass="rig_tooltip_info"
                                class="text-blue-lucide" style="white-space: pre-wrap; font-family: monospace;"
                                [matTooltip]="getTooltipContent(reg.meta_data | policyMetaDataJsonArray:'suggestedName', reg.meta_data | policyMetaDataJsonArray:'Source', reg.meta_data | policyMetaDataJsonArray:'page')">
                            </lucide-icon>
                            <!-- <lucide-icon matTooltipMultiline="true" name="info" class="text-blue-lucide">
                                <ng-container *ngFor="let line of getTooltipContent(reg.meta_data | policyMetaDataJsonArray:'suggestedName', reg.meta_data | policyMetaDataJsonArray:'Source', reg.meta_data | policyMetaDataJsonArray:'page')">
                                    <div>{{ line }}</div>
                                </ng-container>
                            </lucide-icon> -->

                            <input type="checkbox" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-right mt-3" *ngIf="isDescriptionView">
            <button class="btn btn-sm" (click)="getMapData()">Map</button>
            <lucide-icon name="settings" size="20" class="text-blue-lucide cursor-pointer ml-1"
                (click)="openSettings()"></lucide-icon>
        </div>
        <div class="col-12 h-100 mt-2" *ngIf="isDocumentView">
          <div class="card h-100 position-relative">
            <div class="card-header" *ngIf="showPdf">
              <nav class="d-flex align-items-center justify-content-center gap-10">
                <button (click)="prevPage()" [disabled]="page === 1" class="previous btn btn-sm">
                  <lucide-icon size="15" name="move-left"></lucide-icon>
                </button>
                <p class="mb-0">{{ page }} / {{ totalPages }}</p>
                <button (click)="nextPage()" [disabled]="page === totalPages" class="next btn btn-sm">
                  <lucide-icon size="15" name="move-right"></lucide-icon>
                </button>
                <button class="border-0 p-0 bg-transparent" (click)="zoomIn()"><lucide-icon class="text-blue-lucide"
                    name="zoom-in"></lucide-icon></button>
                <button class="border-0 p-0 bg-transparent" (click)="zoomOut()"><lucide-icon class="text-blue-lucide"
                    name="zoom-out"></lucide-icon></button>
              </nav>
            </div>
            <div class="card-body py-4">
              <pdf-viewer *ngIf="showPdf" [src]="pdfContent" [render-text]="true" [original-size]="false"
                (after-load-complete)="afterLoadComplete($event)" [show-all]="true" [external-link-target]="'blank'"
                [(page)]="page" [zoom]="zoomLevel" [zoom-scale]="'page-width'" (onError)="onPdfError($event)"
                [fit-to-page]="true" [autoresize]="true" [show-toolbar]="true" (onPageChange)="onPageChanged($event)"
                class="content w-100 h-100">
              </pdf-viewer>
            </div>
          </div>
        </div>
    </div>
    <div class=" py-3 pl-3">
        <mat-tab-group class="rig_innertab" [(selectedIndex)]="selectRightTabIndex"
            (selectedTabChange)="tabMenuChanged($event)">
            <mat-tab label="Policy Matches">
            </mat-tab>
            <mat-tab label="MAPS Dashboard"></mat-tab>
        </mat-tab-group>

        <app-progress-bar [isLoading]="isLoadingPolicy"></app-progress-bar>
        <div class="row pdf-rigHeight_row">
            <div class="col-12 h-100 mt-2" *ngIf="isMapDashboardView">
                <div class="card animated fadeInLeftBig">
                    <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
                    <div class="card-body">
                        <div *ngIf="joseToken && joseToken.message" class="regulatory_body_card">
                            <iframe width="100%" height="100%" [src]="streamlitUrl | safe"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" *ngIf="isPolicyView">
                <div class="scroll_part">
                    <div class="policyView_table mb-4" *ngIf="isShowTable">
                        <caption>Mappped Documents</caption>
                        <div class="table_main" [ngClass]="isPolicyDataLoaded ? 'activePolicy': ''">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 150px;">Relevance Score</th>
                                        <th style="width: 350px;">Name</th>
                                        <th style="width: 150px;">Section</th>
                                        <th style="width: 150px;">Sub-Section1</th>
                                        <th style="width: 150px;">Sub-Section2</th>
                                        <th style="width: 150px;">Sub-Section3</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="cursor-pointer" (click)="GetPolicies(policy.policyName)"
                                        *ngFor="let policy of matchPolicies">
                                        <td style="width: 150px;">{{policy.relevance_score}}</td>
                                        <td style="width: 350px;">{{policy.policyName}}</td>
                                        <td style="width: 150px;">{{policy.policySection}}</td>
                                        <td style="width: 150px;">{{policy.policySubSection1}}</td>
                                        <td style="width: 150px;">{{policy.policySubSection2}}</td>
                                        <td style="width: 150px;">{{policy.policySubSection3}}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="editor change-viewer-rig" *ngIf="isShowPolicyText">
                        <app-ck-editor [(childVariable)]="policyText" [data]="policyText"></app-ck-editor>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
